import { Suspense, lazy, } from 'react'
import { Routes, Route, Navigate, } from 'react-router-dom'
import * as routesNames from '../../constant/routes'
import Layout from '../../default/Layout'
import { useAuth } from '../../hooks/useAuth'
import Loader from '../../components/Loader'






const Login = lazy(() => import('../Login'));
const ForgotPassword = lazy(() => import('../ForgotPassword'));
const ResetPassword = lazy(() => import('../ResetPassword'));
const Dashboard = lazy(() => import('../Dashboard'));
const UpdatePassword = lazy(() => import('../UpdatePassword'));
const Users = lazy(() => import('../AdminControl/users'));
const CentralLeads = lazy(() => import('../CentralLead/LeadPool'));
const SharedLead = lazy(() => import('../SharedLead/sharedLead'));
const CrmWebhook = lazy(() => import('../Masters/CrmWebhook/crmWebhook'));
const SourceSystem = lazy(() => import('../Masters/SourceSystem/sourceSystem'));


const AppRoutes = () => {
  const { loggedin } = useAuth();

  return (
    <Routes>
      {
        !loggedin ? (
          <>
            <Route path={"/login"} element={<Suspense><Login /></Suspense>} />
            <Route path="*" element={<Navigate to={"/login"} />} />
            <Route path={routesNames.FORGOTPASSWORD} element={<Suspense><ForgotPassword /></Suspense>} />
            <Route path={routesNames.RESETPASSWORD} element={<Suspense><ResetPassword /></Suspense>} />
          </>
        ) : (
          <>
           (<Route path={routesNames.DASHBOARD} element={<Suspense fallback={<Loader />}><Layout><Dashboard /></Layout></Suspense>} />)         
            (<Route path={routesNames.USERS} element={<Suspense fallback={<Loader />}><Layout><Users /></Layout></Suspense>} />)
            (<Route path={routesNames.LEADPOOL} element={<Suspense fallback={<Loader />}><Layout><CentralLeads /></Layout></Suspense>} />)
            (<Route path={routesNames.SHAREDLEAD} element={<Suspense fallback={<Loader />}><Layout><SharedLead /></Layout></Suspense>} />)
            (<Route path={routesNames.CRMWEBHOOK} element={<Suspense fallback={<Loader />}><Layout><CrmWebhook /></Layout></Suspense>} />)
            (<Route path={routesNames.SOURCESYSTEM} element={<Suspense fallback={<Loader />}><Layout><SourceSystem /></Layout></Suspense>} />)
            <Route path="*" element={<Navigate to={routesNames.DASHBOARD} />} />
          </>
        )
      }
    </Routes>
  );
};


export default AppRoutes
